import { AxiosHeaders, type InternalAxiosRequestConfig } from "axios";

/**
 * Ensures multipart uploads omit Content-Type so the browser sets the boundary.
 * JSON requests get application/json when a body is present.
 */
export function normalizeRequestHeaders(config: InternalAxiosRequestConfig): void {
  const headers = AxiosHeaders.from(config.headers ?? {});

  if (config.data instanceof FormData) {
    headers.delete("Content-Type");
    headers.delete("content-type");
    config.headers = headers;
    return;
  }

  const method = (config.method ?? "get").toLowerCase();
  const hasBody = config.data !== undefined && config.data !== null;
  if (hasBody && method !== "get" && method !== "head" && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  config.headers = headers;
}

/** Paths that must not trigger silent token refresh (public patron registration). */
export function isRegistrationPublicApiUrl(url: string | undefined): boolean {
  if (!url) return false;
  const path = url.split("?")[0];
  if (path.includes("/registration-config")) return true;
  if (/\/registration\/(status\/|verify-email|public\/|resend-verification-email)/.test(path)) {
    return true;
  }
  return /\/registration$/.test(path);
}
